// This file is generated by scripts/generate-proto-crud-services.ts

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension="
// @generated from file _gen.user.service.proto (package user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from '@bufbuild/protobuf'
import { Message, proto3 } from '@bufbuild/protobuf'
import { User } from './_gen.models_pb'
import { Error } from './core_pb'

/**
 * @generated from message user.v1.GetUserByIdRequest
 */
export class GetUserByIdRequest extends Message<GetUserByIdRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<GetUserByIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUserByIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserByIdRequest {
    return new GetUserByIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserByIdRequest {
    return new GetUserByIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserByIdRequest {
    return new GetUserByIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUserByIdRequest | PlainMessage<GetUserByIdRequest> | undefined,
    b: GetUserByIdRequest | PlainMessage<GetUserByIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetUserByIdRequest, a, b)
  }
}

/**
 * @generated from message user.v1.GetUserByIdResponse
 */
export class GetUserByIdResponse extends Message<GetUserByIdResponse> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetUserByIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUserByIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'user', kind: 'message', T: User },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserByIdResponse {
    return new GetUserByIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserByIdResponse {
    return new GetUserByIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserByIdResponse {
    return new GetUserByIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUserByIdResponse | PlainMessage<GetUserByIdResponse> | undefined,
    b: GetUserByIdResponse | PlainMessage<GetUserByIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetUserByIdResponse, a, b)
  }
}

/**
 * @generated from message user.v1.GetUserByCognitoUserIdRequest
 */
export class GetUserByCognitoUserIdRequest extends Message<GetUserByCognitoUserIdRequest> {
  /**
   * @generated from field: string cognitoUserId = 1;
   */
  cognitoUserId = ''

  constructor(data?: PartialMessage<GetUserByCognitoUserIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUserByCognitoUserIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'cognitoUserId', kind: 'scalar', T: 9 /* ScalarType.STRING */ }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserByCognitoUserIdRequest {
    return new GetUserByCognitoUserIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserByCognitoUserIdRequest {
    return new GetUserByCognitoUserIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserByCognitoUserIdRequest {
    return new GetUserByCognitoUserIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUserByCognitoUserIdRequest | PlainMessage<GetUserByCognitoUserIdRequest> | undefined,
    b: GetUserByCognitoUserIdRequest | PlainMessage<GetUserByCognitoUserIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetUserByCognitoUserIdRequest, a, b)
  }
}

/**
 * @generated from message user.v1.GetUserByCognitoUserIdResponse
 */
export class GetUserByCognitoUserIdResponse extends Message<GetUserByCognitoUserIdResponse> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetUserByCognitoUserIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUserByCognitoUserIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'user', kind: 'message', T: User },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserByCognitoUserIdResponse {
    return new GetUserByCognitoUserIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserByCognitoUserIdResponse {
    return new GetUserByCognitoUserIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserByCognitoUserIdResponse {
    return new GetUserByCognitoUserIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUserByCognitoUserIdResponse | PlainMessage<GetUserByCognitoUserIdResponse> | undefined,
    b: GetUserByCognitoUserIdResponse | PlainMessage<GetUserByCognitoUserIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetUserByCognitoUserIdResponse, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersByEmailRequest
 */
export class GetUsersByEmailRequest extends Message<GetUsersByEmailRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetUsersByEmailRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersByEmailRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'email', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersByEmailRequest {
    return new GetUsersByEmailRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersByEmailRequest {
    return new GetUsersByEmailRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersByEmailRequest {
    return new GetUsersByEmailRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUsersByEmailRequest | PlainMessage<GetUsersByEmailRequest> | undefined,
    b: GetUsersByEmailRequest | PlainMessage<GetUsersByEmailRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetUsersByEmailRequest, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersByEmailResponse
 */
export class GetUsersByEmailResponse extends Message<GetUsersByEmailResponse> {
  /**
   * @generated from field: repeated models.User users = 1;
   */
  users: User[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetUsersByEmailResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersByEmailResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'users', kind: 'message', T: User, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersByEmailResponse {
    return new GetUsersByEmailResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersByEmailResponse {
    return new GetUsersByEmailResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersByEmailResponse {
    return new GetUsersByEmailResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUsersByEmailResponse | PlainMessage<GetUsersByEmailResponse> | undefined,
    b: GetUsersByEmailResponse | PlainMessage<GetUsersByEmailResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetUsersByEmailResponse, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersByNameRequest
 */
export class GetUsersByNameRequest extends Message<GetUsersByNameRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetUsersByNameRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersByNameRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersByNameRequest {
    return new GetUsersByNameRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersByNameRequest {
    return new GetUsersByNameRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersByNameRequest {
    return new GetUsersByNameRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUsersByNameRequest | PlainMessage<GetUsersByNameRequest> | undefined,
    b: GetUsersByNameRequest | PlainMessage<GetUsersByNameRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetUsersByNameRequest, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersByNameResponse
 */
export class GetUsersByNameResponse extends Message<GetUsersByNameResponse> {
  /**
   * @generated from field: repeated models.User users = 1;
   */
  users: User[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetUsersByNameResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersByNameResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'users', kind: 'message', T: User, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersByNameResponse {
    return new GetUsersByNameResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersByNameResponse {
    return new GetUsersByNameResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersByNameResponse {
    return new GetUsersByNameResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetUsersByNameResponse | PlainMessage<GetUsersByNameResponse> | undefined,
    b: GetUsersByNameResponse | PlainMessage<GetUsersByNameResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetUsersByNameResponse, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersRequest
 */
export class GetUsersRequest extends Message<GetUsersRequest> {
  constructor(data?: PartialMessage<GetUsersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersRequest {
    return new GetUsersRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersRequest {
    return new GetUsersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersRequest {
    return new GetUsersRequest().fromJsonString(jsonString, options)
  }

  static equals(a: GetUsersRequest | PlainMessage<GetUsersRequest> | undefined, b: GetUsersRequest | PlainMessage<GetUsersRequest> | undefined): boolean {
    return proto3.util.equals(GetUsersRequest, a, b)
  }
}

/**
 * @generated from message user.v1.GetUsersResponse
 */
export class GetUsersResponse extends Message<GetUsersResponse> {
  /**
   * @generated from field: repeated models.User users = 1;
   */
  users: User[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetUsersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.GetUsersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'users', kind: 'message', T: User, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUsersResponse {
    return new GetUsersResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUsersResponse {
    return new GetUsersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUsersResponse {
    return new GetUsersResponse().fromJsonString(jsonString, options)
  }

  static equals(a: GetUsersResponse | PlainMessage<GetUsersResponse> | undefined, b: GetUsersResponse | PlainMessage<GetUsersResponse> | undefined): boolean {
    return proto3.util.equals(GetUsersResponse, a, b)
  }
}

/**
 * @generated from message user.v1.CreateUserRequest
 */
export class CreateUserRequest extends Message<CreateUserRequest> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  constructor(data?: PartialMessage<CreateUserRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.CreateUserRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'user', kind: 'message', T: User }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateUserRequest | PlainMessage<CreateUserRequest> | undefined,
    b: CreateUserRequest | PlainMessage<CreateUserRequest> | undefined,
  ): boolean {
    return proto3.util.equals(CreateUserRequest, a, b)
  }
}

/**
 * @generated from message user.v1.CreateUserResponse
 */
export class CreateUserResponse extends Message<CreateUserResponse> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<CreateUserResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.CreateUserResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'user', kind: 'message', T: User },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateUserResponse | PlainMessage<CreateUserResponse> | undefined,
    b: CreateUserResponse | PlainMessage<CreateUserResponse> | undefined,
  ): boolean {
    return proto3.util.equals(CreateUserResponse, a, b)
  }
}

/**
 * @generated from message user.v1.UpdateUserRequest
 */
export class UpdateUserRequest extends Message<UpdateUserRequest> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  constructor(data?: PartialMessage<UpdateUserRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.UpdateUserRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'user', kind: 'message', T: User }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserRequest {
    return new UpdateUserRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserRequest {
    return new UpdateUserRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserRequest {
    return new UpdateUserRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateUserRequest | PlainMessage<UpdateUserRequest> | undefined,
    b: UpdateUserRequest | PlainMessage<UpdateUserRequest> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateUserRequest, a, b)
  }
}

/**
 * @generated from message user.v1.UpdateUserResponse
 */
export class UpdateUserResponse extends Message<UpdateUserResponse> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<UpdateUserResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.UpdateUserResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'user', kind: 'message', T: User },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserResponse {
    return new UpdateUserResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserResponse {
    return new UpdateUserResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserResponse {
    return new UpdateUserResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateUserResponse | PlainMessage<UpdateUserResponse> | undefined,
    b: UpdateUserResponse | PlainMessage<UpdateUserResponse> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateUserResponse, a, b)
  }
}

/**
 * @generated from message user.v1.DeleteUserRequest
 */
export class DeleteUserRequest extends Message<DeleteUserRequest> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  constructor(data?: PartialMessage<DeleteUserRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.DeleteUserRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'user', kind: 'message', T: User }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteUserRequest {
    return new DeleteUserRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteUserRequest {
    return new DeleteUserRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteUserRequest {
    return new DeleteUserRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteUserRequest | PlainMessage<DeleteUserRequest> | undefined,
    b: DeleteUserRequest | PlainMessage<DeleteUserRequest> | undefined,
  ): boolean {
    return proto3.util.equals(DeleteUserRequest, a, b)
  }
}

/**
 * @generated from message user.v1.DeleteUserResponse
 */
export class DeleteUserResponse extends Message<DeleteUserResponse> {
  /**
   * @generated from field: models.User user = 1;
   */
  user?: User

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<DeleteUserResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'user.v1.DeleteUserResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'user', kind: 'message', T: User },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteUserResponse {
    return new DeleteUserResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteUserResponse {
    return new DeleteUserResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteUserResponse {
    return new DeleteUserResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteUserResponse | PlainMessage<DeleteUserResponse> | undefined,
    b: DeleteUserResponse | PlainMessage<DeleteUserResponse> | undefined,
  ): boolean {
    return proto3.util.equals(DeleteUserResponse, a, b)
  }
}
